
export function log (msg) {
  console.log(`${msg} [by '@edu-fe/login' 2018-05-28]`)
}
